module.exports = __webpack_public_path__ + "static/media/trial1-if-correct.a2cb6946.mp3";